import { useTranslation } from "react-i18next";
import logo from "../assets/Telurmix2.png";

const AppContextSwitcher = () => {
  const { t } = useTranslation();

  return (
    <div className="pageContainer">
      <div className="card">
        <div className="card-body">
          <h5 className="card-title">
            <img src={logo} />
          </h5>
          <div
            className="row"
            style={{ justifyContent: "center", textAlign: "center" }}
          >
            <div
              className="card col-4"
              style={{
                margin: "20px",
                border: "2px solid",
                backgroundColor: "azure",
              }}
            >
              <div className="card-body">
                <h5 className="card-title" style={{ fontWeight: "bold" }}>
                  <i
                    className="fas fa-city"
                    style={{ marginRight: "10px" }}
                  ></i>
                  Retail
                </h5>

                <span>Aktuálně nastaveno</span>
                <br />
                <i
                  className="far fa-check-circle fa-2x"
                  style={{ color: "green", marginTop: "10px" }}
                ></i>
              </div>
            </div>
            <div className="card col-4" style={{ margin: "20px" }}>
              <div className="card-body">
                <h5 className="card-title">
                  <i
                    className="fas fa-palette"
                    style={{ marginRight: "10px" }}
                  ></i>
                  Dekorativa
                </h5>

                <button type="button" className="btn btn-primary">
                  Vybrat
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppContextSwitcher;
